// extracted by css-extract-rspack-plugin
export default {"listbox":"IFwV0","item":"mEcOv","icon":"vXHCk","label":"_2C0j","highlight":"qm1jk","footer":"BJDO1","key":"LCqhm"};